<template>
  <div class="page-wrap stack-lg legal-page">
    <SectionTitle eyebrow="Документ" title="Согласие на обработку персональных данных" subtitle="Пользователь дает согласие на хранение и обработку данных в рамках работы приложения {{ brandName }}." />
    <BaseCard class="legal-card stack-md">
      <p>Согласие распространяется на данные, введенные в форме регистрации и профиля: имя, email, телефон, домашний клуб и историю бронирований.</p>
      <p>Данные используются для авторизации, резервирования игровых мест, связи по заявкам и ведения бонусной программы.</p>
      <p>Пользователь вправе отозвать согласие, обратившись в поддержку клуба. При отзыве согласия доступ к части функций приложения может быть ограничен.</p>
    </BaseCard>
  </div>
</template>

<script>
import BaseCard from '../components/ui/BaseCard.vue';
import SectionTitle from '../components/ui/SectionTitle.vue';

export default {
  name: 'PersonalDataConsentView',
  components: { BaseCard, SectionTitle },
};
</script>

<style scoped src="./PersonalDataConsentView.css"></style>
